import React, { useEffect, useRef, useState } from 'react';

// Ease-out count-up from 0 → target on mount / when target changes.
export const useCountUp = (target, dur = 950) => {
  const [v, setV] = useState(0);
  const raf = useRef();
  useEffect(() => {
    const to = Number(target) || 0;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      setV(to * e);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target, dur]);
  return v;
};

export const CountUp = ({ value, render, dur = 950 }) => {
  const v = useCountUp(value, dur);
  return <>{render ? render(v) : Math.round(v)}</>;
};
